<template>
    <div class="ah-page outsourcing-edit-person-page">
        <div class="page-header bottom-margin" id="project-edit-page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1 v-if="!form.sno">新增委外勞務</h1>
                        <h1 v-if="form.sno">編輯委外勞務</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <el-form :model="form" ref="form" label-position="right" label-width="200px" v-loading="isLoading">
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">基本資訊</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="caT_SNO" label="類型" :rules="rules.caT_SNO">
                            <OutsourcingTypeSelect v-model="form.caT_SNO" type="person" />
                        </el-form-item>
                        <el-form-item prop="fnam" :label="form.vdR_TYP == 'VD' ? '廠商名稱' : '姓名'" :rules="rules.fnam">
                            <el-input v-model="form.fnam" style="max-width: 480px" @blur="handleNameBlur" :maxlength="50" :show-word-limit="true">
                                <el-select v-model="form.vendorContacts[0].gen" :prop="form.vendorContacts[0].gen" slot="append" style="width: 100px" v-if="form.vendorContacts.length > 0">
                                    <el-option label="先生" :value="0"></el-option>
                                    <el-option label="小姐" :value="1"></el-option>
                                </el-select>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="abd" label="國籍">
                            <el-radio v-model="form.abd" :label="0" @change="onAbdChanged">本國人</el-radio>
                            <el-radio v-model="form.abd" :label="1" @change="onAbdChanged">外國籍（在台已滿183天）</el-radio>
                            <el-radio v-model="form.abd" :label="2" @change="onAbdChanged">外國籍（在台未滿183天）</el-radio>
                        </el-form-item>
                        <el-form-item prop="identificationType" label="證件類型" v-if="form.abd !== 0">
                            <el-radio v-model="form.identificationType" :label="1" @change="onBsnTypChange">護照號碼</el-radio>
                            <el-radio v-model="form.identificationType" :label="2" @change="onBsnTypChange">居留證</el-radio>
                        </el-form-item>
                        <el-form-item prop="bsN_TYP" label="證件類型" v-if="form.abd === 0">
                            <el-radio v-model="form.bsN_TYP" :label="1" @change="onBsnTypChange">身分證</el-radio>
                            <el-radio v-model="form.bsN_TYP" :label="2" @change="onBsnTypChange">營業統一編號</el-radio>
                        </el-form-item>
                        <el-form-item prop="bsn" :label="bsnLabelName" :rules="bsnRule" required key="bsn-form-item">
                            <el-input v-model.trim="form.bsn" style="display: block; width: 300px" />
                        </el-form-item>
                        <el-form-item prop="permanentAdR_CODE" label="戶籍地址郵遞區號">
                            <ah-number-input v-model="form.permanentAdR_CODE" style="display: block; width: 150px" :maxlength="6" :placeholder="form.abd == 0 ? '' : 'ZIP code'"></ah-number-input>
                        </el-form-item>
                        <el-form-item prop="permanentAddr" label="戶籍地址" key="permanent-addr-form-item">
                            <TwCountySelect v-model="form.permanentAddrCty" key="county" v-if="form.abd === 0" style="margin-right: 5px" />
                            <CountrySelect v-else v-model="form.permanentAddrAra" key="country-select" style="margin-bottom: 10px" />
                            <el-input v-model="form.permanentAddr" style="max-width: 500px" :maxlength="50" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item prop="adR_CODE" label="聯絡地址郵遞區號">
                            <div style="display: flex; gap: 12px;">
                                <ah-number-input v-model="form.adR_CODE" style="display: block; width: 150px" :maxlength="6" :placeholder="form.abd == 0 ? '' : 'ZIP code'"></ah-number-input>
                                <el-button size="small" type="primary" plain @click="sameAddrs">同戶籍地址</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item prop="adr" label="聯絡地址" key="addr-form-item">
                            <TwCountySelect v-model="form.cty" key="county" v-if="form.abd === 0" style="margin-right: 5px" />
                            <CountrySelect v-else v-model="form.ara" key="country-select" style="margin-bottom: 10px" />
                            <el-input v-model="form.adr" style="max-width: 500px" :maxlength="50" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item prop="oS_GRP">
                            <template slot="label">投保職業工會<ahTip>有加入職業工會，不用扣二代健保。</ahTip> </template>
                            <el-radio v-model="form.oS_GRP" :label="true">有</el-radio>
                            <el-radio v-model="form.oS_GRP" :label="false">無</el-radio>
                        </el-form-item>
                        <el-form-item v-if="form.oS_GRP" prop="unionInsuranceExpireDate" label="投保工會有效日期">
                            <el-date-picker v-model="form.unionInsuranceExpireDate" type="date" value-format="timestamp" placeholder="選擇日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item prop="idCardFront" label="身分證正反">
                            <div class="document-section">
                                <div>
                                    <div v-if="form.idCardFront" class="document-block">
                                        <el-image :src="form.idCardFront" :previewSrcList="[form.idCardFront]" style="width: 100%; height: 100%" fit="contain"></el-image>
                                    </div>
                                    <ahUploader
                                        :value="form.idCardFront"
                                        ref="ahUploader"
                                        head-shot
                                        accept="image/png, image/jpeg"
                                        :isShowDeleteButton="true"
                                        @change="($event) => onChangeAttachment($event, 'idCardFront')"
                                        :watermark="`僅供 ${companyName} 請款使用`"
                                    ></ahUploader>
                                </div>
                                <div>
                                    <div v-if="form.idCardBack" class="document-block">
                                        <el-image :src="form.idCardBack" :previewSrcList="[form.idCardBack]" style="width: 100%; height: 100%" fit="contain"></el-image>
                                    </div>
                                    <ahUploader
                                        :value="form.idCardBack"
                                        ref="ahUploader"
                                        head-shot
                                        accept="image/png, image/jpeg"
                                        :watermark="`僅供 ${companyName} 請款使用`"
                                        :isShowDeleteButton="true"
                                        @change="($event) => onChangeAttachment($event, 'idCardBack')"
                                    />
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item prop="unionInsuranceDoc" label="投保工會證明文件">
                            <div class="document-section">
                                <div>
                                    <div v-if="form.unionInsuranceDoc" class="document-block">
                                        <el-image :src="form.unionInsuranceDoc" :previewSrcList="[form.unionInsuranceDoc]" style="width: 100%; height: 100%" fit="contain"></el-image>
                                    </div>
                                    <ahUploader
                                        :value="form.unionInsuranceDoc"
                                        ref="ahUploader"
                                        head-shot
                                        accept="image/png, image/jpeg"
                                        :watermark="`僅供 ${companyName} 請款使用`"
                                        :isShowDeleteButton="true"
                                        @change="($event) => onChangeAttachment($event, 'unionInsuranceDoc')"
                                    />
                                </div>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <OutsourcingBankListEdit v-model="form.vendorBanks" :form="form" @add="onAddVenderBank" @delete="onDeleteVenderBank" />
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">聯絡資訊</div>
                    </div>
                    <div class="panel-body">
                        <div v-for="(contact, index) in form.vendorContacts" :key="contact.key" class="contact-card">
                            <el-form-item :prop="'vendorContacts.' + index + '.nam'" label="姓名" v-if="form.vdR_TYP == 'VD'">
                                <el-input v-model="contact.nam" class="input-with-select" style="max-width: 300px" :maxlength="50" :show-word-limit="true">
                                    <el-select v-model="contact.gen" :prop="'contacts.' + index + '.gen'" slot="append" style="width: 100px">
                                        <el-option label="先生" :value="0"></el-option>
                                        <el-option label="小姐" :value="1"></el-option>
                                    </el-select>
                                </el-input>
                            </el-form-item>
                            <el-form-item :prop="'vendorContacts.' + index + '.tel'" label="電話">
                                <el-input v-model="contact.tel" style="max-width: 300px" :maxlength="20" :show-word-limit="true"></el-input>
                                <el-input v-model="contact.ext" style="max-width: 150px; margin-left: 10px" placeholder="分機" :maxlength="10" :show-word-limit="true"></el-input>
                            </el-form-item>
                            <el-form-item :prop="'vendorContacts.' + index + '.eml'" label="E-mail">
                                <el-input v-model="contact.eml" style="max-width: 500px" :maxlength="100" :show-word-limit="true"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">其他</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="note" label="備註">
                            <el-input type="textarea" :autosize="{ minRows: 5 }" placeholder="" v-model="form.note" :maxlength="200" :show-word-limit="true"> </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div v-if="form.sno" style="text-align: right; color: #aaa; margin-bottom: 20px">
                    <span style="margin-right: 10px">最後編輯</span>
                    <span>{{ form.upD_USR }}</span>
                    <span style="margin-left: 10px">{{ form.upD_DAT | dateFormater("YYYY-MM-dd") }}</span>
                </div>
                <center>
                    <el-button type="dark" @click="handleDelete" v-if="form.sno">刪除</el-button>
                    <el-button @click="onBack()">取消</el-button>
                    <el-button type="primary" @click="onSubmit" :loading="isSubmitting" class="primary-action" style="width: 150px">{{ form.sno ? "儲存" : "新增" }}</el-button>
                </center>
            </el-form>
        </div>
    </div>
</template>
<script>
import CountrySelect from '@/components/ui/CountrySelect.vue';
import TwCountySelect from '@/components/ui/TwCountySelect.vue';
import OutsourcingTypeSelect from '@/components/ui/OutsourcingTypeSelect.vue';
import OutsourcingBankListEdit from '@/components/dashboard/Outsourcing/OutsourcingBankListEdit.vue';
import { isGuiNumberValid, isNationalIdentificationNumberValid } from 'taiwan-id-validator';
import ahNumberInput from '@/components/ui/ahNumberInput.vue';
import ahUploader from '@/components/ui/Uploader/ahUploader.vue';

export default {
    name: 'OutsouringEditPage',
    components: {
        CountrySelect,
        TwCountySelect,
        OutsourcingTypeSelect,
        OutsourcingBankListEdit,
        ahNumberInput,
        ahUploader,
    },
    computed: {
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
        bsnLabelName() {
            if (this.form.abd === 0) {
                if (this.form.bsN_TYP === 1) return '身分證號碼';
                if (this.form.bsN_TYP === 2) return '營業統一編號';
            }
            if (this.form.abd !== 0) {
                if (this.form.identificationType === 1) return '護照號碼';
                if (this.form.identificationType === 2) return '居留證';
            }

            return '---';
        },
        outsourcingTypes() {
            if (this.form.vdR_TYP === 'VD') return this.vendorSettings_VD;
            return this.vendorSettings_OS;
        },
        bsnRule() {
            if (this.form.abd === 0) {
                if (this.form.bsN_TYP === 1) return this.rules.bsn_id;
                if (this.form.bsN_TYP === 2) return this.rules.bsn_comp;
            }

            return [{ required: true, message: `請輸入${this.bsnLabelName}` }];
        },
    },
    data() {
        const validateBsnComp = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入統一編號。'));
            } else if (!isGuiNumberValid(value, true)) {
                callback(new Error('統一編號格式不正確'));
            } else {
                callback();
            }
        };

        const validateBsnId = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入身分證號碼。'));
            } else if (!isNationalIdentificationNumberValid(value)) {
                callback(new Error('身分證號碼格式不正確'));
            } else {
                callback();
            }
        };

        return {
            bankList: [],
            branchList: [],
            vendorSettings_OS: [],
            vendorSettings_VD: [],
            isLoading: false,
            isBankBranchLoading: false,
            isSubmitting: false,
            vendorDeleteBanks: [],
            form: {
                mno: 0, // 編號
                vdR_TYP: 'OS', // 類型（CL=客戶,VD=廠商,OS=外包）
                oS_TYP: null,
                caT_SNO: null,
                cnam: '', // 簡稱
                fnam: '', // 全名
                bsn: '', // 統編或身份證字號或護照
                bsN_NO: 0, // 無統編
                adr: '', // 地址,
                abd: 0, // 國籍 0=本國籍, 1=外國籍(在台已滿183天) 2=外國籍(在台未滿183天)
                identificationType: 1, // 外國人證件號碼類型： 1= 護照, 2= 居留證
                bsN_TYP: 1, // 證件號碼類型： 1= 個人身分證 2=營業統一編號
                abD_TYP: null, // 0政府/1公營事業/2民間
                onf: 1, // 啟用
                bilL_DAY: '1', // 結帳日
                soO_DAY: '1', // 收款日
                adR_CODE: '',
                permanentAdR_CODE: '',
                ara: '',
                cty: '',
                permanentAddr: '',
                permanentAddrCty: '',
                permanentAddrAra: '',
                voo: '',
                note: '',
                oS_GRP: false,
                unionInsuranceExpireDate: null,
                unionInsuranceDoc: '',
                idCardFront: '',
                idCardBack: '',
                passbookDoc: '',
                vendorContacts: [],
                vendorBanks: [
                    {
                        accountType: 1,
                        abroadBankName: '',
                        bnK_BOO: null,
                        bnK_DOO: null,
                        bnK_ACC: '',
                        bnK_TPC: '',
                        filE_AGREE: null,
                        note: '',
                        passbookDoc: '',
                        swiftCode: '',
                    },
                ],
                vendorBank: {
                    bnK_BOO: null,
                    bnK_DOO: null,
                    bnK_ACC: '',
                    bnK_TPC: '',
                    abroadBankName: null,
                    swiftCode: null,
                },
            },
            rules: {
                oS_TYP: [
                    {
                        required: true,
                        message: '請選擇類型',
                        trigger: 'change',
                    },
                ],
                fnam: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (!value || value.trim() === '') {
                                callback(new Error('請輸入姓名'));
                            } else if (value.length < 2) {
                                callback(new Error('姓名至少需2個字元'));
                            } else {
                                callback();
                            }
                        },
                    },
                ],
                caT_SNO: [
                    {
                        required: true,
                        message: '請選擇類型',
                        trigger: 'change',
                    },
                ],
                bsn_id: [{ required: true, validator: validateBsnId, trigger: 'blur' }],
                bsn_comp: [{ required: true, validator: validateBsnComp, trigger: 'blur' }],
            },
        };
    },

    mounted() {
        this.fetchTypeSettings();
        this.fetchBankList();

        // 網址中含有序號，進入編輯模式，取得資料並載入
        const { sno } = this.$route.params;
        if (sno) this.fetchExistData(sno);
        // 新增模式
        else this.addContact();
    },
    methods: {
        handleNameBlur() {
            if (this.form.fnam) {
                this.form.fnam = this.form.fnam.trim();
            }
            if (this.form.vendorBank.bnK_TPC === '') {
                this.form.vendorBank.bnK_TPC = this.form.fnam;
            }
        },
        removeContact(item) {
            const index = this.form.vendorContacts.indexOf(item);
            if (index !== -1) {
                this.form.vendorContacts.splice(index, 1);
            }
        },
        fetchBankList() {
            this.$api({
                url: '/Tool/GetBankOptions',
                method: 'GET',
            }).then((resp) => {
                this.bankList = resp.data.options;
            });
        },
        fetchBranchList(value, refresh = true) {
            if (refresh) this.form.vendorBank.bnK_DOO = '';
            if (value) {
                this.isBankBranchLoading = true;
                this.$api({
                    url: `/Tool/GetBranchOptions?BOO=${value}`,
                    method: 'get',
                }).then((resp) => {
                    this.branchList = resp.data.options;
                    this.isBankBranchLoading = false;
                });
            }
        },
        fetchTypeSettings() {
            this.$api({
                url: '/Tool/GetDepartmentAndVendorSettings',
                method: 'get',
            }).then((resp) => {
                this.vendorSettings_OS = resp.data.vendorSettings_OS;
                this.vendorSettings_VD = resp.data.vendorSettings_VD;
            });
        },
        fetchExistData(sno) {
            this.isLoading = true;
            this.$api({
                url: `Outsourcing/GetOutsourcingInfo?sno=${sno}`,
                method: 'GET',
            }).then((resp) => {
                this.isLoading = false;

                // 如果沒有銀行資料，就補空資訊
                if (resp.data.item.vendorBank == null) {
                    resp.data.item.vendorBank = {
                        sno: resp.data.item.sno,
                        bnK_BOO: null,
                        bnK_DOO: null,
                        bnK_ACC: '',
                        bnK_TPC: '',
                    };
                }

                // 如果沒有聯絡人資料，就補空資訊
                this.form = resp.data.item;
                if (this.form.vendorContacts.length <= 0) this.addContact();

                // 載入分行下拉選單
                setTimeout(() => {
                    this.fetchBranchList(resp.data.item.vendorBank.bnK_BOO, false);
                }, 50);
                //

                //
                console.log('Outsourcing: ', resp.data.item);
            });
        },
        onTypeChanged() {
            this.form.oS_TYP = null;
        },
        onAbdChanged() {
            // 本國人
            if (this.form.abd === 0) {
                this.form.abD_TYP = null;
                this.form.ara = null;
                this.form.permanentAddrAra = null;
                if (!this.form.bsN_TYP) this.form.bsN_TYP = 1;
            }

            // 外國人（境外）
            if (this.form.abd !== 0) {
                this.form.abD_TYP = 2;
            }
            this.onResetFormValidation();
        },
        handleDelete() {
            this.$confirm('確認要刪除？', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            })
                .then(() => {
                    this.submitDelete();
                })
                .catch(() => {});
        },
        submitDelete() {
            this.$api({
                method: 'DELETE',
                url: 'Outsourcing/DeleteOutsourcingDetail',
                data: {
                    sno: this.form.sno,
                    vdR_TYP: this.form.vdR_TYP,
                },
            }).then(() => {
                this.onBack();
            });
        },
        addContact() {
            this.form.vendorContacts.push({
                key: Date.now(),
                nam: '',
                gen: 0,
                job: '',
                tel: '',
                ext: '',
                eml: '',
                dep: '',
            });
        },
        onSubmit() {
            // 表單驗證
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.form.abd === 0) {
                        this.form.abD_TYP = null;
                        this.form.ara = null;
                        this.form.permanentAddrAra = null;
                        this.form.identificationType = 0;
                    }

                    // 境外 資料刪除
                    if (this.form.abd !== 0) {
                        this.form.bsN_TYP = 0;
                        this.form.cty = null;
                        this.form.permanentAddrCty = null;
                    }

                    this.form.vendorBanks.forEach((item) => {
                        if (item.accountType === 1) {
                            item.abroadBankName = null;
                            item.swiftCode = null;
                        } else if (item.accountType === 2) {
                            item.bnK_BOO = null;
                            item.bnK_DOO = null;
                        }
                    });

                    this.form.fnam = this.form.fnam.trim();
                    console.log(this.form);

                    this.$api({
                        url: 'Outsourcing/UpsertOutsourcingDetail',
                        data: {
                            ...this.form,
                            vendorBanks: [...this.form.vendorBanks, ...this.vendorDeleteBanks],
                        },
                        method: 'POST',
                        crossdomain: true,
                    }).then((resp) => {
                        console.log('outsource-added', resp);

                        this.onBack('person', resp.data.sno);
                    });
                } else {
                    this.scrollViewToError();
                }
            });
        },
        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },
        reset() {
            this.form.fnam = '';
            this.form.cnam = '';
            this.form.bsn = '';
            this.form.adr = '';
            this.form.bilL_DAY = '';
            this.form.soO_DAY = '';
            this.form.vendorContacts = [];
            this.form.adR_CODE = '';
            this.form.permanentAdR_CODE = '';
            this.form.ara = '';
            this.form.cty = '';
            this.form.voo = '';
            this.currStep = 1;
            this.addContact();
        },
        onBack(outsourcingtype, outsourcingsno) {
            if (this.$route.query.from === 'payment-add') {
                this.$router.push({
                    name: 'payment-add',
                    query: { cache: 1, outsourcingtype, outsourcingsno },
                });
            } else this.$router.push({ name: 'outsourcing', query: { typ: 'os' } });
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        onBsnTypChange() {
            this.onResetFormValidation();
        },
        onAddVenderBank() {
            this.form.vendorBanks.push({
                accountType: 1,
                bnK_BOO: null,
                bnK_DOO: null,
                bnK_ACC: '',
                bnK_TPC: '',
                filE_AGREE: null,
                note: '',
            });
        },
        onDeleteVenderBank(index) {
            const targetBank = this.form.vendorBanks[index];
            if (targetBank) {
                const copyBank = JSON.parse(JSON.stringify(targetBank));
                copyBank.deleted = true;
                this.vendorDeleteBanks.push(copyBank);
                this.form.vendorBanks.splice(index, 1);
            }
        },
        onResetFormValidation() {
            this.$refs.form.clearValidate();
        },

        onChangeAttachment(val, fieldName) {
            if (val) {
                this.form[fieldName] = val.filE_ATT;
            } else {
                this.form[fieldName] = null;
            }
        },
        sameAddrs() {
            this.form.adR_CODE = this.form.permanentAdR_CODE;
            this.form.adr = this.form.permanentAddr;
            this.form.cty = this.form.permanentAddrCty;
            this.form.ara = this.form.permanentAddrAra;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.outsourcing-edit-person-page {
    .document-section {
        display: flex;
        > * {
            margin-right: 10px;
        }
    }
    .document-block {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 100px;
        border: 1px solid #aaa;
        cursor: pointer;
        .el-icon-plus {
            font-size: 30px;
            color: #aaa;
        }
    }
}
</style>
